import { render, staticRenderFns } from "./StepFrontlineSocialCareWorker.vue?vue&type=template&id=53b2bd37&scoped=true&"
import script from "./StepFrontlineSocialCareWorker.vue?vue&type=script&lang=js&"
export * from "./StepFrontlineSocialCareWorker.vue?vue&type=script&lang=js&"
import style0 from "./StepFrontlineSocialCareWorker.vue?vue&type=style&index=0&id=53b2bd37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b2bd37",
  null
  
)

export default component.exports